/**
 * kc-animations.js
 * Global animation engine for Lumen theme.
 * Uses IntersectionObserver for scroll-triggered reveals.
 * Respects prefers-reduced-motion.
 */

(function () {
  'use strict';

  const ANIMATE_ATTR = 'data-animate';
  const ANIMATED_CLASS = 'kc-animated';
  const VISIBLE_CLASS = 'kc-visible';

  // Skip all animations if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  if (prefersReducedMotion) {
    document.querySelectorAll(`[${ANIMATE_ATTR}]`).forEach(el => {
      el.classList.add(ANIMATED_CLASS, VISIBLE_CLASS);
    });
    return;
  }

  /** Parse animation config from data attribute */
  function getConfig(el) {
    try {
      return JSON.parse(el.dataset.animationConfig || '{}');
    } catch {
      return {};
    }
  }

  /** Apply staggered delay to children of a group */
  function applyStagger(group) {
    const config = getConfig(group);
    const stagger = config.stagger || 80;
    const baseDelay = config.delay || 0;

    group.querySelectorAll('[data-animate-item]').forEach((item, i) => {
      item.style.transitionDelay = `${baseDelay + i * stagger}ms`;
      item.style.animationDelay = `${baseDelay + i * stagger}ms`;
    });
  }

  /** IntersectionObserver callback */
  function onIntersect(entries, observer) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      el.classList.add(VISIBLE_CLASS);
      observer.unobserve(el);
    });
  }

  const observer = new IntersectionObserver(onIntersect, {
    threshold: 0.12,
    rootMargin: '0px 0px -48px 0px',
  });

  /** Init — observe all animatable elements */
  function init() {
    // Mark all animated elements
    document.querySelectorAll(`[${ANIMATE_ATTR}]`).forEach(el => {
      el.classList.add(ANIMATED_CLASS);
      observer.observe(el);
    });

    // Apply stagger to groups
    document.querySelectorAll('[data-animate-group]').forEach(group => {
      applyStagger(group);
      group.querySelectorAll('[data-animate-item]').forEach(item => {
        item.classList.add(ANIMATED_CLASS);
        observer.observe(item);
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify section renders (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
